const formatOffset = (offset) => {
    const sign = offset >= 0 ? "+" : "-";
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset);
    const minutes = (absOffset % 1) * 60;
    if (minutes === 0) {
        return `UTC ${sign}${hours.toString().padStart(2, "0")}:00`;
    }
    return `UTC ${sign}${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};
export const TIMEZONE_OPTIONS = [
    { value: "Etc/GMT+12", label: `(${formatOffset(-12)}) Baker Island`, offset: -12 },
    { value: "Pacific/Midway", label: `(${formatOffset(-11)}) Midway Island`, offset: -11 },
    { value: "Pacific/Niue", label: `(${formatOffset(-11)}) Niue`, offset: -11 },
    { value: "Pacific/Pago_Pago", label: `(${formatOffset(-11)}) American Samoa`, offset: -11 },
    { value: "Pacific/Honolulu", label: `(${formatOffset(-10)}) Hawaii`, offset: -10 },
    { value: "Pacific/Tahiti", label: `(${formatOffset(-10)}) Tahiti`, offset: -10 },
    { value: "Pacific/Rarotonga", label: `(${formatOffset(-10)}) Cook Islands`, offset: -10 },
    { value: "Pacific/Marquesas", label: `(${formatOffset(-9.5)}) Marquesas Islands`, offset: -9.5 },
    { value: "America/Anchorage", label: `(${formatOffset(-9)}) Alaska`, offset: -9 },
    { value: "Pacific/Gambier", label: `(${formatOffset(-9)}) Gambier Islands`, offset: -9 },
    { value: "America/Los_Angeles", label: `(${formatOffset(-8)}) Los Angeles, Pacific Time`, offset: -8 },
    { value: "America/Vancouver", label: `(${formatOffset(-8)}) Vancouver`, offset: -8 },
    { value: "America/Tijuana", label: `(${formatOffset(-8)}) Tijuana`, offset: -8 },
    { value: "Pacific/Pitcairn", label: `(${formatOffset(-8)}) Pitcairn Islands`, offset: -8 },
    { value: "America/Denver", label: `(${formatOffset(-7)}) Denver, Mountain Time`, offset: -7 },
    { value: "America/Phoenix", label: `(${formatOffset(-7)}) Phoenix, Arizona`, offset: -7 },
    { value: "America/Edmonton", label: `(${formatOffset(-7)}) Edmonton`, offset: -7 },
    { value: "America/Mazatlan", label: `(${formatOffset(-7)}) Mazatlan`, offset: -7 },
    { value: "America/Chicago", label: `(${formatOffset(-6)}) Chicago, Central Time`, offset: -6 },
    { value: "America/Mexico_City", label: `(${formatOffset(-6)}) Mexico City`, offset: -6 },
    { value: "America/Guatemala", label: `(${formatOffset(-6)}) Guatemala`, offset: -6 },
    { value: "America/Costa_Rica", label: `(${formatOffset(-6)}) Costa Rica`, offset: -6 },
    { value: "America/El_Salvador", label: `(${formatOffset(-6)}) El Salvador`, offset: -6 },
    { value: "America/Winnipeg", label: `(${formatOffset(-6)}) Winnipeg`, offset: -6 },
    { value: "America/New_York", label: `(${formatOffset(-5)}) New York, Eastern Time`, offset: -5 },
    { value: "America/Toronto", label: `(${formatOffset(-5)}) Toronto`, offset: -5 },
    { value: "America/Bogota", label: `(${formatOffset(-5)}) Bogota, Colombia`, offset: -5 },
    { value: "America/Lima", label: `(${formatOffset(-5)}) Lima, Peru`, offset: -5 },
    { value: "America/Panama", label: `(${formatOffset(-5)}) Panama`, offset: -5 },
    { value: "America/Jamaica", label: `(${formatOffset(-5)}) Jamaica`, offset: -5 },
    { value: "America/Havana", label: `(${formatOffset(-5)}) Havana, Cuba`, offset: -5 },
    { value: "America/Cancun", label: `(${formatOffset(-5)}) Cancun`, offset: -5 },
    { value: "America/Halifax", label: `(${formatOffset(-4)}) Halifax, Atlantic Time`, offset: -4 },
    { value: "America/Puerto_Rico", label: `(${formatOffset(-4)}) Puerto Rico`, offset: -4 },
    { value: "America/Caracas", label: `(${formatOffset(-4)}) Caracas, Venezuela`, offset: -4 },
    { value: "America/La_Paz", label: `(${formatOffset(-4)}) La Paz, Bolivia`, offset: -4 },
    { value: "America/Santiago", label: `(${formatOffset(-4)}) Santiago, Chile`, offset: -4 },
    { value: "America/Manaus", label: `(${formatOffset(-4)}) Manaus, Amazon`, offset: -4 },
    { value: "Atlantic/Bermuda", label: `(${formatOffset(-4)}) Bermuda`, offset: -4 },
    { value: "America/Barbados", label: `(${formatOffset(-4)}) Barbados`, offset: -4 },
    { value: "America/St_Johns", label: `(${formatOffset(-3.5)}) Newfoundland`, offset: -3.5 },
    { value: "America/Sao_Paulo", label: `(${formatOffset(-3)}) São Paulo, Brasilia`, offset: -3 },
    { value: "America/Buenos_Aires", label: `(${formatOffset(-3)}) Buenos Aires, Argentina`, offset: -3 },
    { value: "America/Montevideo", label: `(${formatOffset(-3)}) Montevideo, Uruguay`, offset: -3 },
    { value: "Atlantic/Stanley", label: `(${formatOffset(-3)}) Falkland Islands`, offset: -3 },
    { value: "America/Cayenne", label: `(${formatOffset(-3)}) French Guiana`, offset: -3 },
    { value: "America/Paramaribo", label: `(${formatOffset(-3)}) Suriname`, offset: -3 },
    { value: "America/Noronha", label: `(${formatOffset(-2)}) Fernando de Noronha`, offset: -2 },
    { value: "Atlantic/South_Georgia", label: `(${formatOffset(-2)}) South Georgia`, offset: -2 },
    { value: "Atlantic/Azores", label: `(${formatOffset(-1)}) Azores`, offset: -1 },
    { value: "Atlantic/Cape_Verde", label: `(${formatOffset(-1)}) Cape Verde`, offset: -1 },
    { value: "UTC", label: `(${formatOffset(0)}) UTC`, offset: 0 },
    { value: "Europe/London", label: `(${formatOffset(0)}) London, UK`, offset: 0 },
    { value: "Europe/Dublin", label: `(${formatOffset(0)}) Dublin, Ireland`, offset: 0 },
    { value: "Europe/Lisbon", label: `(${formatOffset(0)}) Lisbon, Portugal`, offset: 0 },
    { value: "Atlantic/Reykjavik", label: `(${formatOffset(0)}) Reykjavik, Iceland`, offset: 0 },
    { value: "Africa/Casablanca", label: `(${formatOffset(0)}) Casablanca, Morocco`, offset: 0 },
    { value: "Africa/Accra", label: `(${formatOffset(0)}) Accra, Ghana`, offset: 0 },
    { value: "Africa/Dakar", label: `(${formatOffset(0)}) Dakar, Senegal`, offset: 0 },
    { value: "Africa/Monrovia", label: `(${formatOffset(0)}) Monrovia, Liberia`, offset: 0 },
    { value: "Europe/Paris", label: `(${formatOffset(1)}) Paris, France`, offset: 1 },
    { value: "Europe/Berlin", label: `(${formatOffset(1)}) Berlin, Germany`, offset: 1 },
    { value: "Europe/Madrid", label: `(${formatOffset(1)}) Madrid, Spain`, offset: 1 },
    { value: "Europe/Rome", label: `(${formatOffset(1)}) Rome, Italy`, offset: 1 },
    { value: "Europe/Amsterdam", label: `(${formatOffset(1)}) Amsterdam, Netherlands`, offset: 1 },
    { value: "Europe/Brussels", label: `(${formatOffset(1)}) Brussels, Belgium`, offset: 1 },
    { value: "Europe/Vienna", label: `(${formatOffset(1)}) Vienna, Austria`, offset: 1 },
    { value: "Europe/Stockholm", label: `(${formatOffset(1)}) Stockholm, Sweden`, offset: 1 },
    { value: "Europe/Oslo", label: `(${formatOffset(1)}) Oslo, Norway`, offset: 1 },
    { value: "Europe/Copenhagen", label: `(${formatOffset(1)}) Copenhagen, Denmark`, offset: 1 },
    { value: "Europe/Zurich", label: `(${formatOffset(1)}) Zurich, Switzerland`, offset: 1 },
    { value: "Europe/Warsaw", label: `(${formatOffset(1)}) Warsaw, Poland`, offset: 1 },
    { value: "Europe/Prague", label: `(${formatOffset(1)}) Prague, Czech Republic`, offset: 1 },
    { value: "Africa/Lagos", label: `(${formatOffset(1)}) Lagos, Nigeria`, offset: 1 },
    { value: "Africa/Algiers", label: `(${formatOffset(1)}) Algiers, Algeria`, offset: 1 },
    { value: "Africa/Tunis", label: `(${formatOffset(1)}) Tunis, Tunisia`, offset: 1 },
    { value: "Europe/Athens", label: `(${formatOffset(2)}) Athens, Greece`, offset: 2 },
    { value: "Europe/Bucharest", label: `(${formatOffset(2)}) Bucharest, Romania`, offset: 2 },
    { value: "Europe/Helsinki", label: `(${formatOffset(2)}) Helsinki, Finland`, offset: 2 },
    { value: "Europe/Kiev", label: `(${formatOffset(2)}) Kyiv, Ukraine`, offset: 2 },
    { value: "Europe/Sofia", label: `(${formatOffset(2)}) Sofia, Bulgaria`, offset: 2 },
    { value: "Africa/Cairo", label: `(${formatOffset(2)}) Cairo, Egypt`, offset: 2 },
    { value: "Africa/Johannesburg", label: `(${formatOffset(2)}) Johannesburg, South Africa`, offset: 2 },
    { value: "Africa/Nairobi", label: `(${formatOffset(3)}) Nairobi, Kenya`, offset: 3 },
    { value: "Asia/Jerusalem", label: `(${formatOffset(2)}) Jerusalem, Israel`, offset: 2 },
    { value: "Asia/Beirut", label: `(${formatOffset(2)}) Beirut, Lebanon`, offset: 2 },
    { value: "Asia/Amman", label: `(${formatOffset(2)}) Amman, Jordan`, offset: 2 },
    { value: "Asia/Damascus", label: `(${formatOffset(2)}) Damascus, Syria`, offset: 2 },
    { value: "Europe/Moscow", label: `(${formatOffset(3)}) Moscow, Russia`, offset: 3 },
    { value: "Europe/Istanbul", label: `(${formatOffset(3)}) Istanbul, Turkey`, offset: 3 },
    { value: "Asia/Baghdad", label: `(${formatOffset(3)}) Baghdad, Iraq`, offset: 3 },
    { value: "Asia/Riyadh", label: `(${formatOffset(3)}) Riyadh, Saudi Arabia`, offset: 3 },
    { value: "Asia/Kuwait", label: `(${formatOffset(3)}) Kuwait`, offset: 3 },
    { value: "Asia/Qatar", label: `(${formatOffset(3)}) Doha, Qatar`, offset: 3 },
    { value: "Asia/Bahrain", label: `(${formatOffset(3)}) Bahrain`, offset: 3 },
    { value: "Asia/Aden", label: `(${formatOffset(3)}) Aden, Yemen`, offset: 3 },
    { value: "Africa/Addis_Ababa", label: `(${formatOffset(3)}) Addis Ababa, Ethiopia`, offset: 3 },
    { value: "Asia/Tehran", label: `(${formatOffset(3.5)}) Tehran, Iran`, offset: 3.5 },
    { value: "Asia/Dubai", label: `(${formatOffset(4)}) Dubai, UAE`, offset: 4 },
    { value: "Asia/Muscat", label: `(${formatOffset(4)}) Muscat, Oman`, offset: 4 },
    { value: "Asia/Baku", label: `(${formatOffset(4)}) Baku, Azerbaijan`, offset: 4 },
    { value: "Asia/Tbilisi", label: `(${formatOffset(4)}) Tbilisi, Georgia`, offset: 4 },
    { value: "Asia/Yerevan", label: `(${formatOffset(4)}) Yerevan, Armenia`, offset: 4 },
    { value: "Indian/Mauritius", label: `(${formatOffset(4)}) Mauritius`, offset: 4 },
    { value: "Indian/Reunion", label: `(${formatOffset(4)}) Réunion`, offset: 4 },
    { value: "Asia/Kabul", label: `(${formatOffset(4.5)}) Kabul, Afghanistan`, offset: 4.5 },
    { value: "Asia/Karachi", label: `(${formatOffset(5)}) Karachi, Pakistan`, offset: 5 },
    { value: "Asia/Tashkent", label: `(${formatOffset(5)}) Tashkent, Uzbekistan`, offset: 5 },
    { value: "Asia/Ashgabat", label: `(${formatOffset(5)}) Ashgabat, Turkmenistan`, offset: 5 },
    { value: "Asia/Dushanbe", label: `(${formatOffset(5)}) Dushanbe, Tajikistan`, offset: 5 },
    { value: "Indian/Maldives", label: `(${formatOffset(5)}) Maldives`, offset: 5 },
    { value: "Asia/Kolkata", label: `(${formatOffset(5.5)}) India (IST)`, offset: 5.5 },
    { value: "Asia/Colombo", label: `(${formatOffset(5.5)}) Colombo, Sri Lanka`, offset: 5.5 },
    { value: "Asia/Kathmandu", label: `(${formatOffset(5.75)}) Kathmandu, Nepal`, offset: 5.75 },
    { value: "Asia/Dhaka", label: `(${formatOffset(6)}) Dhaka, Bangladesh`, offset: 6 },
    { value: "Asia/Almaty", label: `(${formatOffset(6)}) Almaty, Kazakhstan`, offset: 6 },
    { value: "Asia/Bishkek", label: `(${formatOffset(6)}) Bishkek, Kyrgyzstan`, offset: 6 },
    { value: "Indian/Chagos", label: `(${formatOffset(6)}) British Indian Ocean`, offset: 6 },
    { value: "Asia/Yangon", label: `(${formatOffset(6.5)}) Yangon, Myanmar`, offset: 6.5 },
    { value: "Indian/Cocos", label: `(${formatOffset(6.5)}) Cocos Islands`, offset: 6.5 },
    { value: "Asia/Bangkok", label: `(${formatOffset(7)}) Bangkok, Thailand`, offset: 7 },
    { value: "Asia/Jakarta", label: `(${formatOffset(7)}) Jakarta, Indonesia`, offset: 7 },
    { value: "Asia/Ho_Chi_Minh", label: `(${formatOffset(7)}) Ho Chi Minh, Vietnam`, offset: 7 },
    { value: "Asia/Phnom_Penh", label: `(${formatOffset(7)}) Phnom Penh, Cambodia`, offset: 7 },
    { value: "Asia/Vientiane", label: `(${formatOffset(7)}) Vientiane, Laos`, offset: 7 },
    { value: "Indian/Christmas", label: `(${formatOffset(7)}) Christmas Island`, offset: 7 },
    { value: "Asia/Singapore", label: `(${formatOffset(8)}) Singapore`, offset: 8 },
    { value: "Asia/Shanghai", label: `(${formatOffset(8)}) Shanghai, China`, offset: 8 },
    { value: "Asia/Hong_Kong", label: `(${formatOffset(8)}) Hong Kong`, offset: 8 },
    { value: "Asia/Taipei", label: `(${formatOffset(8)}) Taipei, Taiwan`, offset: 8 },
    { value: "Asia/Kuala_Lumpur", label: `(${formatOffset(8)}) Kuala Lumpur, Malaysia`, offset: 8 },
    { value: "Asia/Manila", label: `(${formatOffset(8)}) Manila, Philippines`, offset: 8 },
    { value: "Asia/Makassar", label: `(${formatOffset(8)}) Makassar, Indonesia`, offset: 8 },
    { value: "Asia/Brunei", label: `(${formatOffset(8)}) Brunei`, offset: 8 },
    { value: "Australia/Perth", label: `(${formatOffset(8)}) Perth, Australia`, offset: 8 },
    { value: "Australia/Eucla", label: `(${formatOffset(8.75)}) Eucla, Australia`, offset: 8.75 },
    { value: "Asia/Tokyo", label: `(${formatOffset(9)}) Tokyo, Japan`, offset: 9 },
    { value: "Asia/Seoul", label: `(${formatOffset(9)}) Seoul, South Korea`, offset: 9 },
    { value: "Asia/Pyongyang", label: `(${formatOffset(9)}) Pyongyang, North Korea`, offset: 9 },
    { value: "Asia/Jayapura", label: `(${formatOffset(9)}) Jayapura, Indonesia`, offset: 9 },
    { value: "Pacific/Palau", label: `(${formatOffset(9)}) Palau`, offset: 9 },
    { value: "Australia/Darwin", label: `(${formatOffset(9.5)}) Darwin, Australia`, offset: 9.5 },
    { value: "Australia/Adelaide", label: `(${formatOffset(9.5)}) Adelaide, Australia`, offset: 9.5 },
    { value: "Australia/Sydney", label: `(${formatOffset(10)}) Sydney, Australia`, offset: 10 },
    { value: "Australia/Melbourne", label: `(${formatOffset(10)}) Melbourne, Australia`, offset: 10 },
    { value: "Australia/Brisbane", label: `(${formatOffset(10)}) Brisbane, Australia`, offset: 10 },
    { value: "Australia/Hobart", label: `(${formatOffset(10)}) Hobart, Tasmania`, offset: 10 },
    { value: "Pacific/Guam", label: `(${formatOffset(10)}) Guam`, offset: 10 },
    { value: "Pacific/Port_Moresby", label: `(${formatOffset(10)}) Port Moresby, Papua New Guinea`, offset: 10 },
    { value: "Australia/Lord_Howe", label: `(${formatOffset(10.5)}) Lord Howe Island`, offset: 10.5 },
    { value: "Pacific/Noumea", label: `(${formatOffset(11)}) Noumea, New Caledonia`, offset: 11 },
    { value: "Pacific/Guadalcanal", label: `(${formatOffset(11)}) Solomon Islands`, offset: 11 },
    { value: "Pacific/Pohnpei", label: `(${formatOffset(11)}) Pohnpei, Micronesia`, offset: 11 },
    { value: "Asia/Magadan", label: `(${formatOffset(11)}) Magadan, Russia`, offset: 11 },
    { value: "Pacific/Auckland", label: `(${formatOffset(12)}) Auckland, New Zealand`, offset: 12 },
    { value: "Pacific/Fiji", label: `(${formatOffset(12)}) Fiji`, offset: 12 },
    { value: "Pacific/Tarawa", label: `(${formatOffset(12)}) Tarawa, Kiribati`, offset: 12 },
    { value: "Pacific/Majuro", label: `(${formatOffset(12)}) Marshall Islands`, offset: 12 },
    { value: "Pacific/Nauru", label: `(${formatOffset(12)}) Nauru`, offset: 12 },
    { value: "Pacific/Funafuti", label: `(${formatOffset(12)}) Tuvalu`, offset: 12 },
    { value: "Pacific/Wake", label: `(${formatOffset(12)}) Wake Island`, offset: 12 },
    { value: "Asia/Kamchatka", label: `(${formatOffset(12)}) Kamchatka, Russia`, offset: 12 },
    { value: "Pacific/Chatham", label: `(${formatOffset(12.75)}) Chatham Islands`, offset: 12.75 },
    { value: "Pacific/Tongatapu", label: `(${formatOffset(13)}) Tonga`, offset: 13 },
    { value: "Pacific/Enderbury", label: `(${formatOffset(13)}) Phoenix Islands`, offset: 13 },
    { value: "Pacific/Fakaofo", label: `(${formatOffset(13)}) Tokelau`, offset: 13 },
    { value: "Pacific/Kiritimati", label: `(${formatOffset(14)}) Line Islands, Kiribati`, offset: 14 },
];
export const getTimezoneAbbreviation = (timezone) => {
    try {
        const date = new Date();
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            timeZoneName: "short",
        });
        const parts = formatter.formatToParts(date);
        const tzPart = parts.find((p) => p.type === "timeZoneName");
        return tzPart?.value || timezone;
    }
    catch {
        return timezone;
    }
};
export const convertISTToTimezone = (timeStr, dateStr, targetTimezone) => {
    try {
        if (targetTimezone === "Asia/Kolkata") {
            return formatTimeSimple(timeStr);
        }
        const paddedTime = timeStr.length < 5 ? timeStr.padStart(5, "0") : timeStr;
        const istDateStr = `${dateStr}T${paddedTime}:00+05:30`;
        const date = new Date(istDateStr);
        return date.toLocaleTimeString("en-US", {
            timeZone: targetTimezone,
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    }
    catch {
        return formatTimeSimple(timeStr);
    }
};
const formatTimeSimple = (timeStr) => {
    try {
        const [hours, minutes] = timeStr.split(":").map(Number);
        const period = hours >= 12 ? "PM" : "AM";
        const hour12 = hours % 12 || 12;
        return `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
    }
    catch {
        return timeStr;
    }
};
export const formatDateToISO = (date) => {
    const year = String(date.getFullYear()).padStart(4, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
export const formatDate = (date) => {
    if (!date)
        return "Not selected";
    try {
        const dateObj = typeof date === "string" ? new Date(date) : date;
        return dateObj.toLocaleDateString("en-US", {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
        });
    }
    catch {
        return String(date);
    }
};
export const formatTime = (timeStr) => {
    try {
        if (typeof timeStr === "number" || !Number.isNaN(Number(timeStr))) {
            const time = new Date(Number(timeStr));
            return time.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
        }
        if (timeStr.includes(":") && timeStr.length <= 5) {
            const time = new Date(`2000-01-01T${timeStr}`);
            return time.toLocaleTimeString("en-US", {
                hour: "numeric",
                minute: "2-digit",
                hour12: true,
            });
        }
        const time = new Date(timeStr);
        return time.toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });
    }
    catch {
        return String(timeStr);
    }
};
export const calculateDuration = (startTime, endTime, defaultDuration = 60) => {
    if (!startTime || !endTime)
        return defaultDuration;
    try {
        const start = new Date(startTime);
        const end = new Date(endTime);
        const diffMs = end.getTime() - start.getTime();
        const diffMinutes = Math.round(diffMs / (1000 * 60));
        return diffMinutes > 0 ? diffMinutes : defaultDuration;
    }
    catch {
        return defaultDuration;
    }
};
export { FALLBACK_TIMEZONE, detectBrowserTimezone, normalizeTimezone, getTimezoneOffsetHours, resolveBrowserTimezone, getTimezoneOptions, } from "../../../utils/timezone";
